import { BaseMapper } from 'src/data/common/BaseMapper'

import { CustomerAPI, CustomerModel } from './type'

export class CustomerMapper extends BaseMapper {
  apiMapper = (user: CustomerAPI): CustomerModel => ({
    id: user.id,
    first_name: user.first_name,
    last_name: user.last_name,
    full_name: user.name ?? user.display_name,
    email: user.email,
    birthdate: user.birthdate,
    language: user.language,
    gender: user.gender,
    country: user.country_code,
    subscribed: user.subscribed,
    phone: user.phone,
    mobile_opt_in: user.mobile_opt_in,
    is_from_canada: user.country_code === 'CA',
    parents: user.parents,
    has_child: user.children?.length > 0,
    is_child: user.is_child,
    is_loyalty_member: user.is_loyalty_member,
    children: user.children?.map((child) => {
      return {
        id: child.id,
        first_name: child.first_name,
        last_name: child.last_name,
        full_name: child.name ?? child.display_name,
        email: child.email,
        birthdate: child.birthdate,
        language: child.language,
        gender: child.gender,
        country: child.country_code,
        subscribed: child.subscribed,
        phone: child.phone,
        mobile_opt_in: child.mobile_opt_in,
        is_from_canada: child.country_code === 'CA',
        parents: child.parents,
        is_child: child.is_child,
        is_loyalty_member: child.is_loyalty_member,
        has_child: child.children?.length > 0,
        children: [],
      }
    }) ?? []
  })

  public static defaultValue: CustomerModel = {
    id: 0,
    first_name: '',
    last_name: '',
    full_name: '',
    email: '',
    birthdate: '',
    language: 'en',
    gender: '',
    country: '',
    subscribed: false,
    phone: '',
    mobile_opt_in: false,
    is_from_canada: false,
    is_child: false,
    parents: [],
    has_child: false,
    children: [],
    is_loyalty_member: false,
  }
}
